import React, { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import Button from "../../../../atoms/Button";
import "./style.scss";

interface Props {
  onCancel?: () => void;
  onValidate: () => void;
}

const PanelValidation: FunctionComponent<Props> = ({ onCancel, onValidate }) => {
  const intl = useIntl();

  return (
    <div className="PanelValidation">
      {!!onCancel && (
        <Button type="neutral" onClick={onCancel}>
          {intl.formatMessage({ id: "kustom_ConfirmModal_cancel" })}
        </Button>
      )}
      <Button type="primary" onClick={onValidate}>
        {intl.formatMessage({ id: "kustom_OptionsPanel_apply" })}
      </Button>
    </div>
  );
};

export default PanelValidation;
